import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  DashboardOutlined,
  UserOutlined,
  ContactsOutlined,
  MessageOutlined,
  BankOutlined,
  BuildOutlined,
  PoweroffOutlined,
  DownOutlined,
  UpOutlined,
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import "./Sidebar.css";
import Sider from "antd/es/layout/Sider";
import { ICONS } from "../ui/icons";

const Sidebar = ({ onLogout, collapsed, onToggle, isMobile }) => {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const isCompaniesActive =
    location.pathname === "/companies" || location.pathname === "/offers";

  const savedCompaniesState =
    localStorage.getItem("openCompanies") === "true" ? true : false;

  const [openCompanies, setOpenCompanies] = useState(
    isCompaniesActive || savedCompaniesState
  );

  useEffect(() => {
    if (isCompaniesActive) {
      setOpenCompanies(true);
      localStorage.setItem("openCompanies", "true");
    } else {
      setOpenCompanies(false);
      localStorage.setItem("openCompanies", "false");
    }
  }, [isCompaniesActive]);

  const handleToggleCompanies = () => {
    setOpenCompanies(!openCompanies);
    localStorage.setItem("openCompanies", !openCompanies ? "true" : "false");
  };

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout",
      text: "Are you sure you want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F9243E",
      confirmButtonText: "Logout",
    });
    if (result.isConfirmed) {
      onLogout();
    }
  };

  return (
    <>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <aside
          className={`sidebar ${collapsed ? "sidebar-collapsed" : ""} ${
            isMobile && !collapsed ? "sidebar-mobile-overlay" : ""
          }`}
        >
          {/* Header */}
          <header className="p-4 border-bottom border-light">
            <div className="d-flex align-items-center justify-content-between">
              {collapsed ? (
                <img src={ICONS.LOGO} alt="Logo" className="header-logo" />
              ) : (
                <>
                  <h6 className="sidebar-title">AI Calling Agent</h6>
                  {isMobile && (
                    <CloseOutlined
                      className="sidebar-close-btn"
                      onClick={onToggle}
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    />
                  )}
                </>
              )}
            </div>
          </header>

          {/* Nav */}
          <nav className="pb-4 flex-grow-1">
            {collapsed ? (
              <Tooltip title="Dashboard" placement="right">
                <Link
                  to="/"
                  className={`sidebar-link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                >
                  <DashboardOutlined className="collapsed-sidebar-icon" />
                </Link>
              </Tooltip>
            ) : (
              <Link
                to="/"
                className={`sidebar-link ${
                  location.pathname === "/" ? "active" : ""
                }`}
              >
                <DashboardOutlined className="sidebar-icon" /> Dashboard
              </Link>
            )}

            {/* {collapsed ? (
              <Tooltip title="Agents" placement="right">
                <Link
                  to="/agents"
                  className={`sidebar-link ${
                    location.pathname === "/agents" ? "active" : ""
                  }`}
                >
                  <UserOutlined className="collapsed-sidebar-icon" />
                </Link>
              </Tooltip>
            ) : (
              <Link
                to="/agents"
                className={`sidebar-link ${
                  location.pathname === "/agents" ? "active" : ""
                }`}
              >
                <UserOutlined className="sidebar-icon" /> Agents
              </Link>
            )} */}

            {/* Companies Dropdown */}
            {collapsed ? (
              <Tooltip title="Companies" placement="right">
                <button
                  className={`sidebar-dropdown-btn ${
                    isCompaniesActive ? "active" : ""
                  }`}
                  onClick={handleToggleCompanies}
                >
                  <BankOutlined className="collapsed-sidebar-icon" />
                </button>
              </Tooltip>
            ) : (
              <button
                className={`sidebar-dropdown-btn ${
                  isCompaniesActive ? "active" : ""
                }`}
                onClick={handleToggleCompanies}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <BankOutlined className="sidebar-icon" />
                  Companies
                </span>
                <DownOutlined
                  className={`sidebar-dropdown-arrow ${
                    openCompanies ? "open" : "closed"
                  }`}
                />
              </button>
            )}

            {openCompanies && (
              <div>
                {collapsed ? (
                  <Tooltip title="All Companies" placement="right">
                    <Link
                      to="/companies"
                      className={`sidebar-link sidebar-sublink ${
                        location.pathname === "/companies" ? "active" : ""
                      }`}
                    >
                      <BankOutlined className="collapsed-sidebar-icon" />
                    </Link>
                  </Tooltip>
                ) : (
                  <Link
                    to="/companies"
                    className={`sidebar-link sidebar-sublink ${
                      location.pathname === "/companies" ? "active" : ""
                    }`}
                  >
                    All Companies
                  </Link>
                )}
                {/* {collapsed ? (
                  <Tooltip title="Offers" placement="right">
                    <Link
                      to="/offers"
                      className={`sidebar-link sidebar-sublink ${
                        location.pathname === "/offers" ? "active" : ""
                      }`}
                    >
                      <BankOutlined className="collapsed-sidebar-icon" />
                    </Link>
                  </Tooltip>
                ) : (
                  <Link
                    to="/offers"
                    className={`sidebar-link sidebar-sublink ${
                      location.pathname === "/offers" ? "active" : ""
                    }`}
                  >
                    Offers
                  </Link>
                )} */}
              </div>
            )}

            {collapsed ? (
              <Tooltip title="Contacts" placement="right">
                <Link
                  to="/contacts"
                  className={`sidebar-link ${
                    location.pathname === "/contacts" ? "active" : ""
                  }`}
                >
                  <ContactsOutlined className="collapsed-sidebar-icon" />
                </Link>
              </Tooltip>
            ) : (
              <Link
                to="/contacts"
                className={`sidebar-link ${
                  location.pathname === "/contacts" ? "active" : ""
                }`}
              >
                <ContactsOutlined className="sidebar-icon" /> Contacts
              </Link>
            )}

            {collapsed ? (
              <Tooltip title="Campaigning" placement="right">
                <Link
                  to="/batch-calls"
                  className={`sidebar-link ${
                    location.pathname === "/batch-calls" ? "active" : ""
                  }`}
                >
                  <BuildOutlined className="collapsed-sidebar-icon" />
                </Link>
              </Tooltip>
            ) : (
              <Link
                to="/batch-calls"
                className={`sidebar-link ${
                  location.pathname === "/batch-calls" ? "active" : ""
                }`}
              >
                <BuildOutlined className="sidebar-icon" /> Campaigning
              </Link>
            )}

            {collapsed ? (
              <Tooltip title="Reports" placement="right">
                <Link
                  to="/conversations"
                  className={`sidebar-link ${
                    location.pathname === "/conversations" ? "active" : ""
                  }`}
                >
                  <MessageOutlined className="collapsed-sidebar-icon" />
                </Link>
              </Tooltip>
            ) : (
              <Link
                to="/conversations"
                className={`sidebar-link ${
                  location.pathname === "/conversations" ? "active" : ""
                }`}
              >
                <MessageOutlined className="sidebar-icon" /> Reports
              </Link>
            )}
          </nav>

          {/* Profile */}
          <div className="sidebar-profile">
            {!collapsed && (
              <>
                <div className="sidebar-avatar flex-shrink-0">
                  {user.email.charAt(0).toUpperCase()}
                </div>
                <div className="sidebar-profile-info">
                  <div className="sidebar-profile-name">
                    {user.email.split("@")[0]}
                  </div>
                </div>
              </>
            )}

            <Tooltip title="Logout" placement="top">
              <PoweroffOutlined
                className="sidebar-power"
                onClick={handleLogout}
              />
            </Tooltip>
          </div>
        </aside>
      </Sider>
    </>
  );
};

export default Sidebar;
